import { NgIf } from '@angular/common';
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { DialogService } from '@core/services/dialog.service';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
  imports: [ButtonComponent],
})
export class InfoCardComponent {
  @ViewChild('infoContent') infoContent: TemplateRef<any>;

  @Input() header: string;

  constructor(private dialog: DialogService) {}

  openDialog(): void {
    this.dialog.open(this.infoContent);
  }

  closeModal() {
    this.dialog.closeAll();
  }
}
